module.exports = __webpack_public_path__ + "img/img.1e6d6ff0.jpg";